import React from 'react';
import './closed.css';
import kermainverted from '../../assets/kermainverted.png';
import 'aos/dist/aos.css';
import img2 from '../../assets/jarvispics/newpic.jpg';

const Closed = () => {
  return (
    <section className="comingsoon" id="comingsoon">
      <div className="background-header">
        <img src={kermainverted} className="logo-closed" alt="kerma-logo" />
        <h4 className="closed-text">
          <span className="closed-kiitos">Tervehdys</span>
          <h3 className="juhannus-text"><span className="heart">♡</span>Lauantaina 19.7.avoinna klo 12 alkaen <br></br> Tervetuloa seuraamaan terassille Watercross Tahko tapahtumaa <span className="heart">♡</span></h3>
          <div className="juhannus-text"><span className="accent">Lämpimästi tervetuloa!</span>
          </div>

          <div className="email-phone">Tahkolahdentie 5, 73310 Tahkovuori <span className="line">| </span> ravintola@tahkonkerma.fi <span className="line">|</span> +358 50 4064012</div>
        </h4>
        
        <img src={img2} className="background-image" alt="kerma-background" />
      </div>
    </section>
  );
};

export default Closed;
